import axios from 'axios';
import { Hole, Message } from '../types';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://192.168.100.104:5000/api',
});

// 验证口令格式
const validatepwdFormat = (pwd: string): boolean => {
  // 检查是否符合 x.y.z 格式
  const parts = pwd.split('.');
  if (parts.length !== 3) return false;

  // 验证每个部分是否符合规则（0-6个字符，可以是英文字母、数字、下划线或中文）
  const regex = /^[\u4e00-\u9fa5a-zA-Z0-9_]{0,6}$/;
  return parts.every(part => regex.test(part));
};

// 创建虫洞
export const createHole = async (name: string, pwd?: string) => {
  const response = await api.post<{ hole_id: string; pwd: string }>('/holes', {
    name,
    pwd,
  });
  return response.data;
};

export const verifypwd = async (pwd: string) => {
  if (!validatepwdFormat(pwd)) {
    throw new Error('口令格式不正确');
  }
  const response = await api.post<Hole>('/holes/verify', { pwd });
  return response.data;
};

export const getMessages = async (
    holeId: string,
    sort: string = 'created_desc',
    params: {
        lastId?: string;
        beforeId?: string;
        limit?: number;
    } = {}
) => {
    const response = await api.get<{
        messages: Message[];
        has_more: boolean;
    }>(`/holes/${holeId}/messages`, {
        params: {
            sort,
            ...params
        },
    });
    return response.data;
};

export const sendMessage = async (
  holeId: string,
  content: string,
  type: 'text' | 'code' | 'image',
  expireIn: number = 7200
) => {
  const response = await api.post<{ message_id: string }>(
    `/holes/${holeId}/messages`,
    { content, type, expire_in: expireIn }
  );
  return response.data;
};

export const uploadImage = async (holeId: string, file: File) => {
  const formData = new FormData();
  formData.append('image', file);
  
  const response = await api.post<{ message_id: string; file_path: string }>(
    `/holes/${holeId}/images`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const updateMessageExpiration = async (
  holeId: string,
  messageId: string,
  expireIn: number
) => {
  const response = await api.patch(`/holes/${holeId}/messages/${messageId}`, {
    expire_in: expireIn,
  });
  return response.data;
};

export const getHoleInfo = async (holeId: string) => {
  const response = await api.get<Hole>(`/holes/${holeId}`);
  return response.data;
};

export const uploadFile = async (holeId: string, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post<{ message_id: string; file_path: string }>(
    `/holes/${holeId}/files`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};
 